'use client';

export const dynamic = 'force-dynamic'; // This line forces the page to be dynamically rendered
import Image from 'next/image';
import React, { useEffect, useState, Suspense } from 'react';
import { FaLaptopCode, FaPlug, FaCogs, FaAdjust } from 'react-icons/fa'; // Importing the icons
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import { CircularProgress } from '@mui/material';
import axios from 'axios';  
import { FaInstagram } from 'react-icons/fa';


const ServiceDetails = () => {
  const [services, setServices] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Custom API Development");
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openIndex, setOpenIndex] = useState(null); // To keep track of the currently open dropdown

  useEffect(() => {
    const fetchProjects = async () => {
        try {
            const response = await axios.get('/api/projects');
            const result = response.data;
            setProjects(result);
            const responseServices = await axios.get('/api/home');
            setServices(responseServices.data.services);
            console.log(services)
        } catch (error) {
            console.log('ERROR MESSAGE: ', error);
        } finally {
            setLoading(false);
        }
    };

    fetchProjects();
}, []);

const extractOverview = (text) => {
  const overviewStart = text.indexOf('Overview:');
  const overallDescStart = text.indexOf('Overall Description');

  if (overviewStart === -1 || overallDescStart === -1) {
      return 'Overview section not found';
  }

  // Extract the text between 'Overview' and 'Overall Description'
  const overviewText = text.slice(overviewStart + 'Overview:'.length, overallDescStart).trim();
  return overviewText;
};


const handleCategoryChange = (category) => {
    setSelectedCategory(category);
};

const filteredProjects = selectedCategory === "All"
    ? projects
    : projects.filter((project) => project.category === selectedCategory);

if (loading) {
    return (
        <div className="flex justify-center items-center h-screen">
            <CircularProgress />
        </div>
    );
}

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the dropdown
  };

  return (
    <>
      {/* Banner Section */}
      <div className='mt-20'>
          <section
              className="relative w-full h-40 sm:h-64 md:h-96 bg-cover bg-center bg-no-repeat"
              style={{ backgroundImage: "url('/services_banner.webp')" }}
          >
              <div className="absolute bottom-4 right-4 px-4 py-2 bg-white p-4 rounded-lg shadow-lg">
                  <p className="text-sm text-blue-600 font-medium">
                      <a className='text-black font-bold' href="/">Home</a> / {selectedCategory}
                  </p>
              </div>
          </section>
      </div>

      {/* First Info Section */}
      <section className="overflow-hidden lg:px-16 bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center">
        <div className="p-8 md:p-12 lg:px-32 lg:py-24">
          <div className="mx-auto max-w-xl">
            <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">
            Custom API Development Services
            </h1>
            <p className="text-gray-500 mt-4">
            At Data Pulse Technologies, our custom API development services support a range of integration protocols, including REST, SOAP, XML, and RPC API. Our developers have extensive experience creating custom application programming interfaces using these protocols to ensure seamless  API integration between your systems. We specialize in building custom REST APIs to enhance your current off-the-shelf solution or integrate third-party public APIs that enables your software solution to seamlessly interface with other apps, devices, and business systems.
            </p>
            
          </div>
        </div>

        <Image
          alt=""
          src="/service-images/capid/API.png"
          width={1770}  // Add the width
          height={1000} // Add the height
          className="w-full h-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        />
      </section>
      {/* CTA Section */}
      <div
        style={{ backgroundImage: `url('/map.webp')`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        className="px-4 py-8 text-white sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-48 bg-gray-800"
      >
        <div className="text-left">
          <h2 className="text-3xl font-bold text-white">
            Get Free Mockups and SEO Report
          </h2>
          <p className="mt-2 text-sm font-medium text-white">
            We offer a variety of IT services designed to support your success.
          </p>
        </div>

        <a
          className="mt-4 inline-block rounded-full bg-white px-6 py-3 text-left text-sm font-medium text-black transition hover:bg-black/90 hover:text-white focus:outline-none focus:ring active:text-indigo-500 sm:mt-0"
          href="#"
        >
          GET A QUOTE
        </a>
      </div>

      <section className="overflow-hidden lg:px-16 bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center">
        <div className="p-8 md:p-12 lg:px-32 lg:py-24">
          <div className="mx-auto max-w-xl">
            <h1 className="text-2xl font-bold text-gray-900 md:text-3xl">
            Quality Assurance in API Development
            </h1>
            <p className="text-gray-500 mt-4">
            Our engineers and quality assurance (QA) specialists use automated unit testing, functional testing, and load testing tools and best practices to check and learn from the performance & functionality of mission-critical business apps.
            </p>
            
          </div>
        </div>

        <Image
          alt=""
          src="/service-images/capid/What-is-an-API.png"
          width={1770}  // Add the width
          height={1000} // Add the height
          className="w-full h-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        />
      </section>



      {/* Services Details Section */}
      <section className="overflow-hidden bg-gray-50 lg:px-16 sm:grid sm:grid-cols-2 sm:items-center">
        <div className="p-8 md:p-12 lg:px-32 lg:py-24">
          <div className="mx-auto max-w-xl text-left">
            <h2 className="text-4xl font-bold text-gray-900 md:text-4xl">
            Types of APIs:
            </h2>

            <p className="text-gray-500 mt-4">
            APIs are widely used in web applications, and there are four main types of APIs: public, partner, private, and composite.
            </p>

            {/* Service 1 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaLaptopCode size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Public APIs:</h3>
                <p className="text-gray-500">
                Open to all developers and intended for external use, facilitating broad integration and access.
                </p>
              </div>
            </div>

            {/* Service 2 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaPlug size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Partner APIs:</h3>
                <p className="text-gray-500">
                Shared with specific business partners, requiring registration and providing controlled access to select functionalities.
                </p>
              </div>
            </div>

            {/* Service 3 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaCogs size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Private APIs:</h3>
                <p className="text-gray-500">
                Designed for internal use within an organization, enhancing internal systems and workflows without external exposure.
                </p>
              </div>
            </div>

            {/* Service 4 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaAdjust size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Composite APIs:</h3>
                <p className="text-gray-500">
                Allow multiple endpoints to be accessed in a single call, streamlining interactions with complex data sources.
                </p>
              </div>
            </div>
          </div>
        </div>

        <Image
          alt="Custom WordPress Development"
          src="/service-images/capid/what-is-an-api.jpg"
          width={1770}  // Add the width
          height={1000} // Add the height
          className="w-full h-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        />
      </section>


      <section className="overflow-hidden bg-gray-50 lg:px-16 sm:grid sm:grid-cols-2 sm:items-center">
        <div className="p-8 md:p-12 lg:px-32 lg:py-24">
          <div className="mx-auto max-w-xl text-left">
            <h2 className="text-4xl font-bold text-gray-900 md:text-4xl">
            Types of Custom API Development Projects:
            </h2>

            {/* <p className="text-gray-500 mt-4">
            APIs are widely used in web applications, and there are four main types of APIs: public, partner, private, and composite.
            </p> */}

            {/* Service 1 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaLaptopCode size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">RESTful and GraphQL APIs:</h3>
                <p className="text-gray-500">
                Building scalable APIs that handle complex data requirements efficiently.
                </p>
              </div>
            </div>

            {/* Service 2 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaPlug size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Third-party Integrations:</h3>
                <p className="text-gray-500">
                Seamless integration with external services like social media, payment gateways, and CRM systems.                </p>
              </div>
            </div>

            {/* Service 3 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaCogs size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">API Documentation and Security:</h3>
                <p className="text-gray-500">
                Providing comprehensive documentation and securing APIs with encryption and token-based authentication.
                </p>
              </div>
            </div>

            {/* Service 4 */}
            <div className="flex items-start mt-6 space-x-4">
              <div className="w-12 h-12 text-indigo-600">
                <FaAdjust size={48} />
              </div>
              <div>
                <h3 className="text-lg font-bold text-gray-900">Performance Optimization:</h3>
                <p className="text-gray-500">
                Enhancing API speed and efficiency to handle higher volumes of requests.
                </p>
              </div>
            </div>
          </div>
        </div>

        <Image
          alt="Custom WordPress Development"
          src="/service-images/capid/rest.png"
          width={1770}  // Add the width
          height={1000} // Add the height
          className="w-full h-full object-cover sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]"
        />
      </section>



      {/* <Suspense fallback={<div>Loading Services...</div>}>
        <div>
          <section className="px-8 lg:px-48 py-16 bg-white grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="flex justify-center">
              <Image
                src="/service-images/web/web-development.jpg"
                alt="WordPress Services"
                width={600}  // Add a width property
                height={400} // Add a height property (adjust as per the actual image dimensions)
                className="w-full max-w-lg"
              />
            </div>
            
            <div>
              <h2 className="text-4xl font-bold text-gray-900">Types of Web Development</h2>
              <p className="mt-4 text-gray-500 lg:pr-16">
              There are three main types of web development: front-end development, back-end development, and full-stack development. 
              </p>
            </div>
          </section>

          <section className="px-8 lg:px-48 py-16 bg-white grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900">Front-End Development</h2>
              <p className="mt-4 text-gray-500">
              Front-End Web Developers transform visual designs into code, serving as a bridge between design concepts and technology implementation.
              </p>
            </div>

            <div className="flex justify-center">
              <Image
                src="/func.webp"
                alt="WordPress Functionality"
                width={600}  // Add a width property
                height={400} // Add a height property (adjust as per the actual image dimensions)
                className="w-full max-w-lg"
              />
            </div>
          </section>

          <section className="px-8 lg:px-48 py-16 bg-white grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="flex justify-center">
              <Image
                src="/service-images/web/back.webp"
                alt="WordPress Services"
                width={600}  // Add a width property
                height={400} // Add a height property (adjust as per the actual image dimensions)
                className="w-full max-w-lg"
              />
            </div>
            
            <div>
              <h2 className="text-4xl font-bold text-gray-900">Back-End Development</h2>
              <p className="mt-4 text-gray-500 lg:pr-16">
              Back-end developers are responsible for site functionality, ensuring responsiveness and speed by building servers with modern frameworks, developing custom APIs, and managing databases.
              </p>
            </div>
          </section>

          <section className="px-8 lg:px-48 py-16 bg-white grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900">Full-Stack Development</h2>
              <p className="mt-4 text-gray-500">
              A Full-Stack Developer is skilled in both front- and back-end development, understanding various programming languages and often taking on leadership roles due to their versatility.
              </p>
            </div>

            <div className="flex justify-center">
              <Image
                src="/service-images/web/web-programming-languages.webp"
                alt="WordPress Functionality"
                width={600}  // Add a width property
                height={400} // Add a height property (adjust as per the actual image dimensions)
                className="w-full max-w-lg"
              />
            </div>
          </section>
        </div>
      </Suspense> */}

      {/* <Suspense fallback={<div>Loading Services...</div>}>
        <section className="py-16 px-4 md:px-16 lg:px-32 bg-white">
        <div className="max-w-screen-xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-6">
            Choosing Data Pulse Technologies for custom WordPress development services will take you ahead!
          </h2>
          <p className="text-center text-gray-500 mb-12">
            With the right WordPress website, you will have the right digital presence. Thus, we make sure our custom WordPress development services are aligned with the market standards and client demands. The following are some of the reasons we are the best pick for you among the rest:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-6 shadow-lg rounded-lg transition-transform transform hover:scale-105 duration-300"
              >
                <div
                  className="flex items-center justify-between cursor-pointer"
                  onClick={() => toggleDropdown(index)}
                >
                  <div className="flex items-center">
                    {openIndex === index ? (
                      <FaMinusCircle size={32} className="text-blue-500 mr-4" />
                    ) : (
                      <FaPlusCircle size={32} className="text-blue-500 mr-4" />
                    )}
                    <h3 className="text-lg font-semibold">{service.title}</h3>
                  </div>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    openIndex === index ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="mt-4 text-gray-500">
                    {service.description}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      </Suspense> */}

      <Suspense fallback={<div>Loading Testimonials...</div>}>
      <div className="pt-32">
            {/* Category */}
            <section>
                <div className="mx-auto max-w-screen-xl px-4 lg:flex lg:h-auto lg:items-center">
                    <div className="mx-auto text-center">
                        <h1 className="text-3xl font-extrabold sm:text-5xl" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>
                            Our Projects
                        </h1>
                        <p className="mt-4 sm:text-xl" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>
                            Empowering dreams through meticulous craftsmanship and dedicated innovation, we bring your visions to life, project by project.
                        </p>
                        <fieldset className="flex mt-8 flex-wrap gap-3 justify-center">
                            <legend className="sr-only">Category</legend>
                            <div>
                                <a
                                    href="#"
                                    className={`flex cursor-pointer items-center justify-center rounded-md border border-sky-600 px-4 py-3 text-gray-900 hover:border-gray-200 hover:scale-105 transition transform duration-300 ease-in-out ${selectedCategory === "All" ? "border-blue-500 bg-sky-600 text-white" : "border-sky-600"}`}
                                    onClick={() => handleCategoryChange("All")}
                                    style={{ cursor: 'pointer' }} // Ensure pointer style on hover
                                >
                                    <input
                                        type="radio"
                                        name="CategoryOption"
                                        value="All"
                                        id="All"
                                        className="sr-only"
                                        checked={selectedCategory === "All"}
                                        onChange={() => handleCategoryChange("All")}
                                    />
                                    <p className="text-1xl font-medium" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>All</p>
                                </a>
                            </div>
                            {services.map((service) => (
                                <div key={service._id}>
                                    <a
                                        href={`#${service.title}`}
                                        className={`flex cursor-pointer items-center justify-center rounded-md border border-sky-600 px-4 py-3 text-gray-900 hover:border-gray-200 hover:scale-105 transition transform duration-300 ease-in-out ${selectedCategory === service.title ? "border-blue-500 bg-sky-600 text-white" : "border-sky-600"}`}
                                        onClick={() => handleCategoryChange(service.title)}
                                        style={{ cursor: 'pointer' }} // Ensure pointer style on hover
                                    >
                                        <input
                                            type="radio"
                                            name="CategoryOption"
                                            value={service.title}
                                            id={service.title}
                                            className="sr-only"
                                            checked={selectedCategory === service.title}
                                            onChange={() => handleCategoryChange(service.title)}
                                        />
                                        <p className="text-1xl font-medium" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>{service.title}</p>
                                    </a>
                                </div>
                            ))}
                        </fieldset>
                        <span className="mt-8 flex">
                            <span className="h-1 flex-1 bg-blue-800"></span>
                            <span className="pl-6"></span>
                        </span>
                    </div>
                </div>
            </section>

            {/* Projects */}
            <section>
                <div className="mx-auto max-w-screen-xl px-2 py-2 sm:px-6 sm:py-8 lg:px-8">
                    <div className="grid gap-8 lg:grid-cols-3">
                        {filteredProjects.map((p) => (
                            <div key={p._id} className="bg-white border rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition transform duration-300 ease-in-out">
                                <a href={
                                    p.title === 'AG Property Manager' ? '/portfolio/ag-project-manager' :
                                    p.title === 'Locum Smart' ? '/portfolio/locum-smart' :
                                    p.title === 'PBT Gateway' ? '/portfolio/pbt-gateway' :
                                    p.title === 'PBT Gateway New Stack' ? '/portfolio/pbt-gateway-new-stack' : '#'
                                }>
                                    <Image
                                    alt={p.title}
                                    src={"/" + p.imageUrl || 'back.webp'}
                                    className="h-64 w-full object-cover"
                                    width={500}
                                    height={500}                          
                                />
                                <div className="p-4">
                                    <h3 className="text-lg font-bold text-gray-900 sm:text-xl" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>{p.title}</h3>
                                    <p className="mt-4 text-gray-700" style={{ fontFamily: 'Poppins, Arial, sans-serif' }}>
                                        {extractOverview(p.description)}
                                    </p>
                                    <div className="flex items-center mt-2 space-x-3">
                                        <a href="https://www.linkedin.com/company/data-pulse-technology/" className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-400">
                                            <svg viewBox="0 0 24 24" fill="currentColor" className="h-5">
                                                <path d="M21.4,0H2.6C1.2,0,0,1.2,0,2.6v18.8C0,22.8,1.2,24,2.6,24h18.8c1.4,0,2.6-1.2,2.6-2.6V2.6C24,1.2,22.8,0,21.4,0z M7.9,20.4H4.5V9.3h3.4V20.4z M6.2,8.2c-1.1,0-1.9-0.7-1.9-1.5c0-0.8,0.7-1.5,1.8-1.5c1.1,0,1.9,0.7,1.9,1.5C8.1,7.5,7.4,8.2,6.2,8.2z M21.5,20.4h-3.4v-5.6c0-1.3,0-3-1.8-3c-1.8,0-2,1.4-2,2.8v5.8h-3.4V9.3h3.2v1.5h0.1c0.5-0.9,1.8-1.9,3.1-1.9c3.4,0,4,2.2,4,5V20.4z"></path>
                                            </svg>
                                        </a>
                                        <a href="https://www.instagram.com/datapulsetechnology/" className="text-gray-500 transition-colors duration-300 hover:text-deep-purple-accent-400" style={{ cursor: 'pointer' }}>
                                            <FaInstagram size={24} />
                                        </a>
                                    </div>
                                    <div className="mt-4">
                                        <p>Year: {p.year}</p>
                                    </div>
                                </div>
                                </a>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
              </Suspense>
    </>
  );
};

export default ServiceDetails;
